import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const PageTitle = ({ children }: Props) => (
  <div className="text-center mb-8 pt-20">
    <h1 className="text-2xl sm:text-4xl font-extrabold text-white tracking-tight">
      {children}
    </h1>
  </div>
);
